// extracted by mini-css-extract-plugin
export var black = "_31-6";
export var brand = "_31-1";
export var ddefault = "_31-0";
export var error = "_31-3";
export var gray = "_31-2";
export var highContrast = "_31-8";
export var outline = "_31-7";
export var success = "_31-5";
export var warning = "_31-4";